import { useOne, useParse, useTranslation } from "@refinedev/core";
import {
  CreateEventStep,
  IAttendantTemplateForm,
  ISimpleEventDetail,
} from "interfaces";
import { Link } from "react-router-dom";
import Button from "components/button";
import { FullScreenLoading } from "components/fullScreenLoading";
import { Templates } from "./templates";
import { endpointService } from "components/shared/services/endpointService";

interface ParticipantTemplatesStepProps {
  eventDetailData: ISimpleEventDetail;
}

export const ViewParticipantTemplatesStep = ({
  eventDetailData,
}: ParticipantTemplatesStepProps) => {
  const { translate } = useTranslation();
  const parse = useParse();
  const { params } = parse();

  const { data, isFetching } = useOne<IAttendantTemplateForm>({
    resource: endpointService.getEventEndpoint("getTemplates", {
      eventId: params?.id,
    }),
    id: "",
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });

  const attendantTemplateDetail = data?.data ?? null;
  if (isFetching) {
    return <FullScreenLoading />;
  }
  return attendantTemplateDetail ? (
    <div className="flex flex-col h-full gap-y-2 sm:gap-y-4">
      <Templates
        attendantTemplateDetail={attendantTemplateDetail}
        eventDetailData={eventDetailData}
      />
      <div
        className="w-full mt-auto px-4 py-4 sm:px-6 bg-white sticky bottom-0 z-[2]"
        style={{ boxShadow: "rgba(0, 0, 0, 0.23) 0px -5px 5px -5px" }}
      >
        <div className="flex items-center justify-end gap-x-4">
          <Link
            to={`/events/sports/${params?.id}?step=${CreateEventStep.BUILD_EVENT_PAGE}`}
          >
            <Button className="min-w-20 bg-white text-brand-500 border border-solid border-brand-500 hover:bg-gray-50 active:bg-gray-100">
              {translate("button.back")}
            </Button>
          </Link>
          <Link
            to={`/events/sports/${params?.id}?step=${CreateEventStep.CREATE_TICKET_PHASE}`}
          >
            <Button
              className={`min-w-20 disabled:opacity-70`}
              disabled={eventDetailData.current_step < params?.step}
            >
              {translate("button.next")}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
